import React from 'react';
import CrudManager from '@/components/admin/CrudManager';

const AdminVerses = () => (
  <CrudManager
    title="Ayurvedic Verses"
    subtitle="Rotating classical wisdom on the homepage. Only cite verifiable verses from Charaka, Sushruta, Ashtanga Hridaya, Bhava Prakasha, Madhava Nidana, Sharangadhara, Kashyapa. Never fabricate."
    endpoint="/admin/verses"
    idField="verse_id"
    columns={[
      { key: 'source_text', label: 'Text' },
      { key: 'chapter', label: 'Chapter' },
      { key: 'translation', label: 'Translation', render: (v) => (v.translation || '').slice(0, 60) + '…' },
      { key: 'active', label: 'Active', render: (v) => v.active ? '✓' : '—' },
    ]}
    initial={{ source_text: '', chapter: '', sanskrit: '', transliteration: '', translation: '', explanation: '', practical_relevance: '', order: 0, active: true }}
    fields={[
      { key: 'source_text', label: 'Classical text', required: true, placeholder: 'Charaka Samhita / Sushruta Samhita / Ashtanga Hridaya…' },
      { key: 'chapter', label: 'Chapter & verse', required: true, placeholder: 'Sutrasthana 15.48' },
      { key: 'sanskrit', label: 'Sanskrit (Devanagari)', type: 'textarea', rows: 2 },
      { key: 'transliteration', label: 'Transliteration (IAST or roman)', type: 'textarea', rows: 2 },
      { key: 'translation', label: 'Accurate English translation', type: 'textarea', rows: 3, required: true },
      { key: 'explanation', label: 'Explanation', type: 'textarea', rows: 3 },
      { key: 'practical_relevance', label: 'Practical relevance / why it matters', type: 'textarea', rows: 2 },
      { key: 'order', label: 'Order', type: 'number' },
      { key: 'active', label: 'Show on site', type: 'checkbox' },
    ]}
  />
);

export default AdminVerses;
